import { render, staticRenderFns } from "./EconomicCalendarByInvesting.vue?vue&type=template&id=95dadcce&"
import script from "./EconomicCalendarByInvesting.vue?vue&type=script&lang=js&"
export * from "./EconomicCalendarByInvesting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports